<template>

  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-list text-primary mr-2"></i>
          Listado de Listas de Distribución
        </h4>
      </b-col>
    </b-row>

    <b-row md="12" class="pb-3">
      <b-col class="col-md-12">
        <b-row md="12">

          <b-card class="w-100">
            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
              Listas de Distribución
              <div>
                <button
                  :disabled="count<1"
                  class="btn btn-primary btn-sm mr-2"
                  @click="exportDistributionLists('csv')">
                  <i class="fa fa-download"></i> CSV
                </button>
                <button
                  :disabled="count<1"
                  class="btn btn-primary btn-sm"
                  @click="exportDistributionLists('xlsx')">
                  <i class="fa fa-download"></i> Excel
                </button>
                <button
                  :disabled="count<1"
                  class="btn btn-primary btn-sm ml-2"
                  @click="exportDistributionLists('pdf')">
                  <i class="fa fa-download"></i> PDF
                </button>
              </div>
            </b-row>
            <b-row md="12" class="mb-3 border-top-primary px-2">
              <b-col class="col-md-9">
                <b-form-group label="Buscar" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                  <b-form-input
                    id="string"
                    name="string"
                    type="text"
                    placeholder="Busqueda general"
                    v-model="entity.string"
                    class="w-100"
                    v-validate="'min:3'"
                    :state="validateState('string')"
                    aria-describedby="check_string"></b-form-input>
                  <div class="text-danger text-right" id="check_string">
                    <small>{{ errors.first('string') }}</small>
                  </div>
                </b-form-group>
              </b-col>

              <b-col class="col-md-3">
                <button
                  class="btn btn-pill btn-primary ml-4 float-right"
                  @click="search">Buscar Lista de Distribución
                </button>
              </b-col>

            </b-row>

            <v-server-table
              :columns="columns"
              :options="options"
              :theme="theme"
              class="dataTable"
              ref="dataDistributionListsTable"
              md="12"
              lg="12"
              sm="12"
              @sorted="tableSorted">
              <template slot="beforeBody">
                <tr v-if="loading">
                  <td class="text-center loading" colspan="7"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                </tr>
              </template>
              <template slot="uuid" slot-scope="props">
                <router-link :to="{ path: '/communications/distribution-list/edit/'+props.row.uuid }" title="Editar Lista de Distribución">
                  <i class="fa fa-pencil"></i>
                </router-link>
                <button
                  v-b-tooltip.hover.top
                  title="Borrar Listas de Distribución"
                  class="btn pb-1 pl-1"
                  @click="deleteDistributionList(props.row.uuid)">
                  <i class="fa fa-trash"></i>
                </button>
              </template>
            </v-server-table>
          </b-card>

        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import Vue from 'vue';
import form from '@/helpers/form';
import {ServerTable, Event} from 'vue-tables-2';
import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
import {downloadJsonAsPdf} from '@/helpers/js-pdf';
import Spinner from 'vue-simple-spinner';
import {deleteDistributionList} from "@/api/distribution-list-api";

Vue.use(ServerTable);

export default {
  name: 'listDistributionLists',
  components: {
    Spinner
  },
  data: function () {
    return {
      topmenu: [
        {
          name: 'Inicio',
          path: '/admin/dashboard',
          brand: 'fa fa-home'
        },
        {
          name: 'Crear Lista de Distribución',
          path: '/communications/distribution-list/add',
          brand: 'fa fa-check-square',
          permissions: ['DISTRIBUTION_LIST_NEW']
        },
      ],
      entity: {
        string: null,
        page: 1,
        itemsPerPage: 10,
      },
      orderBy: {
        column: null,
        ascending: null
      },
      count: 0,
      loading: true,
      options: {
        headings: {
          uuid: {
            text: '',
            id: 'fit'
          },
          name: 'Nombre'
        },
        requestFunction: data => {
          if (this.$store.getters.getFilters[0] !== null) {
            this.entity.string = this.$store.getters.getFilters[0];
          }
          this.entity.page = data.page;
          this.entity.itemsPerPage = data.limit;
          let self = this;
          return axios({
            url: 'distribution-lists/',
            method: 'get',
            params: this.searchFilters
          }).catch(function (e) {
            self.dispatch('error', e);
          }.bind(this));
        },
        responseAdapter: ({data}) => {
          return {
            data: data.distributionLists,
            count: data.count
          }
        },
        columnsClasses: {uuid: "fit"},
        sortable: ['name'],
        filterable: false,
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
        texts: form.tableLabels(),
        pagination: {
          chunk: 10,
          edge: true,
          nav: 'scroll'
        }
      },
      columns: [
        'uuid',
        'name'
      ],
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default'
    }
  },
  mounted() {
    this.$_loadingMixin_showLoading();
    Event.$on('vue-tables.loading', (data) => {
      this.$_loadingMixin_showLoading();
      this.count = 0;
      this.loading = true;
      if (!!document.querySelector('.VueTables__no-results')) {
        document.querySelector('.VueTables__no-results').style.display = 'none';
      }
    });
    Event.$on('vue-tables.loaded', (data) => {
      if (!!data && !!data.data && !!data.data.count) {
        this.count = data.data.count;
      }
      this.$_loadingMixin_hideLoading();
      this.loading = false;
      if (!!document.querySelector('.VueTables__no-results')) {
        document.querySelector('.VueTables__no-results').style.display = 'table-row';
      }
    });

    this.$eventHub.$emit('captureMenu', this.topmenu);
  },
  computed: {
    searchFilters() {
      return {
        string: this.entity.string,
        page: this.entity.page,
        itemsPerPage: this.entity.itemsPerPage,
        orderColumn: this.orderBy.column,
        orderAscending: this.orderBy.ascending ? 1 : 0
      }
    }
  },
  methods: {
    search() {
      let filterData = [];
      filterData.push(this.entity.string);
      this.$store.commit('SET_FILTERS_LIST', filterData);
      this.$refs.dataDistributionListsTable.refresh();
    },
    validate() {
      // FIXME
      return true;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      } else {
        return null;
      }
    },
    normalizeDistributionList(distributionList) {
      return {
        'Nombre': distributionList.name,
      }
    },
    async exportDistributionLists(format) {
      if (this.count > 0) {
        this.$_loadingMixin_showLoading();

        let response = await axios({
          method: 'get',
          url: 'distribution-lists',
          params: {
            page: 1,
            itemsPerPage: this.entity.itemsPerPage,
            string: this.entity.string
          }
        });

        let self = this;
        let rows = response.data.distributionLists.map(function (distributionList) {
          return self.normalizeDistributionList(distributionList);
        });

        if (format === 'csv') {
          downloadJsonAsCsv(rows);
        } else if (format === 'xlsx') {
          downloadJsonAsXlsx(rows);
        } else if (format === 'pdf') {
          downloadJsonAsPdf(rows);
        }

        this.$_loadingMixin_hideLoading();
      }
    },
    tableSorted(data) {
      this.orderBy.column = data.column;
      this.orderBy.ascending = data.ascending;
    },
    async deleteDistributionList(distributionListId) {
      swal({
        title: '¿Estás seguro de eliminar el Lista de Distribución seleccionado?',
        text: "Esta operación no se podrá revertir",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, elimínalo!'
      }).then((result) => {
        if (result.value) {

          this.$_loadingMixin_showLoading();

          deleteDistributionList(distributionListId)
            .then((data) => {
              this.search();
            })
            .catch((error) => {
              this.$_notificationMixin_error('Error en la operación', 'No se ha borrado la Lista de Distribución');
            });

          this.$_loadingMixin_hideLoading();

        }
      });
    },
  },
}
</script>

<style lang="scss">
.VueTables__no-results {
  display: none;
}
</style>
